export function initTOCToggleButton() {
	const TOCButton = document.querySelector('.category .ez-toc-js-icon-con');
	if (!TOCButton) return;

	const TOCIcon = window.ezTOC ? window.ezTOC.fallbackIcon : undefined;
	if (TOCIcon) {
		TOCButton.innerHTML = TOCIcon;
	}
}


